/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.directive('inputFocus', $timeout => ({
    restrict: 'A',

    // On crée un scope vide pour la faire passer enfant
    // du scope dans lequel elle est appellée
    scope: { },

    link(scope, element, attrs) {
        return scope.$on('focus', scope => // Si on timeout pas l'autofocus ne se fait pas
        // de temps en temps
        $timeout(() => element.focus()));
    }
}));
